
import { Component } from 'vue-property-decorator';
import ElementBase from './ElementBase';
import { ClassMap, StyleMap } from '../configuration/ElementConfiguration';
import ImageElementConfiguration from '../configuration/ImageElementConfiguration';

@Component({
  name: 'ImageWA', //image is a reserved name, so we use a workaround for that
  components: {},
})
export default class ImageWA extends ElementBase {
  get imageConfiguration(): ImageElementConfiguration {
    return this.configuration as ImageElementConfiguration;
  }

  get alt(): string {
    return this.imageConfiguration.alt ?? '';
  }

  get url(): string {
    return this.imageConfiguration.url ?? '';
  }

  protected defaultClass(): ClassMap {
    return Object.assign({}, super.defaultClass());
  }

  protected defaultStyle(): StyleMap {
    return Object.assign({}, super.defaultStyle(), { 'object-fit': 'contain' });
  }
}
